import { ReactNode } from "react";
import { DOMAIN } from "../../constants/Global";

interface ITComplianceOnlyProps {
  children: ReactNode;
}

const ITComplianceOnly = ({ children }: ITComplianceOnlyProps) => {
  if (DOMAIN !== "it") return null;
  return <>{children}</>;
};

export default ITComplianceOnly;
